<template>
  <router-link v-if="to" :to="to" class="Btn" :class="styles">
    <div v-if="loading" class="Btn__loadingIconBox">
      <span class="Btn__loadingIcon" />
      <span class="Btn__loadingIcon" />
      <span class="Btn__loadingIcon" />
    </div>
    <div class="Btn__contentBox" :class="{ 'v--icon-btn': hasIcon }">
      <slot />
    </div>
  </router-link>
  <div v-else-if="href && disabled" :class="styles" class="Btn">
    <div v-if="loading" class="Btn__loadingIconBox">
      <span class="Btn__loadingIcon" />
      <span class="Btn__loadingIcon" />
      <span class="Btn__loadingIcon" />
    </div>
    <div class="Btn__contentBox" :class="{ 'v--icon-btn': hasIcon }">
      <slot />
    </div>
  </div>
  <a v-else-if="href" :href="href" :target="target" :class="styles" class="Btn">
    <div v-if="loading" class="Btn__loadingIconBox">
      <span class="Btn__loadingIcon" />
      <span class="Btn__loadingIcon" />
      <span class="Btn__loadingIcon" />
    </div>
    <div class="Btn__contentBox" :class="{ 'v--icon-btn': hasIcon }">
      <slot />
    </div>
  </a>
  <button
    v-else
    class="Btn"
    :class="styles"
    :disabled="disabled"
    @click.prevent="onClick"
  >
    <div v-if="loading" class="Btn__loadingIconBox">
      <span class="Btn__loadingIcon" />
      <span class="Btn__loadingIcon" />
      <span class="Btn__loadingIcon" />
    </div>
    <div class="Btn__contentBox" :class="{ 'v--icon-btn': hasIcon }">
      <slot />
    </div>
  </button>
</template>

<script>
export default {
  name: 'Btn',
  props: {
    to: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '_self',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noMinSize: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    styles() {
      return {
        'Btn--isLoading': this.loading,
        'v--no-min-size': this.noMinSize,
        'v--block': this.block,
        'v--rounded': this.rounded,
        'v--active': this.active,
        'v--outline': this.outline,
        'v--disabled': this.disabled,
      }
    },
  },
  methods: {
    onClick(e) {
      this.$emit('click', e)
    },
  },
}
</script>

<style lang="stylus" src="./style.styl"></style>
